module.exports = "<section class=\"form-elements\">\n    <label class=\"fe-label\">\n        <span class=\"fe-heading\">Comments</span>\n        <span class=\"fe-input\">\n            <textarea class=\"full-width\" placeholder=\"Please type here . . .\" rows=\"5\"></textarea>\n        </span>\n    </label>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/common/letterTemplates/default.html
// module id = 593
// module chunks = 0